import React from 'react';
import Router from 'next/router';
import PropTypes from 'prop-types';

import { Popup } from '../../Boneyard';

import iconClose from '../../../images/overlay-close.png';

const ErrorModal = ({ title, children }) => {
  const navigateToRoot = () => Router.push('/hotel-booking');

  return (
    <Popup
      open
      closeIcon={iconClose}
      onRequestClose={navigateToRoot}
      alt="Close modal"
      title={title}
    >
      {children}
    </Popup>
  );
};

ErrorModal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default ErrorModal;
